export const areas = [
  {
    slug: "psixologos-rio",
    badge: "Ρίο · 10' από το γραφείο",
    metaTitle: "Ψυχολόγος Ρίο · Ψυχοθεραπεία CBT κοντά σου | Άννα Παπαχρονόπουλου",
    metaDescription:
      "Ψυχοθεραπεία για κατοίκους του Ρίου: το γραφείο στη Ρήγα Φεραίου 119 απέχει μόλις 10-15 λεπτά. Γνωσιακή Συμπεριφορική Θεραπεία (CBT) δια ζώσης ή online — και για Αντίρριο & Ναύπακτο.",
    keywords:
      "ψυχολόγος Ρίο, ψυχοθεραπεία Ρίο, ψυχολόγος Ρίο Πάτρας, ψυχολόγος κοντά στο Ρίο, ψυχολόγος Αντίρριο, ψυχολόγος Ναύπακτος, CBT Ρίο",
    h1a: "Ψυχοθεραπεία",
    h1b: "για το Ρίο.",
    sub: "Σε απόσταση αναπνοής.",
    intro:
      "Μένεις στο Ρίο, στον Άγιο Βασίλειο ή στην Πανεπιστημιούπολη; Το γραφείο μου στη Ρήγα Φεραίου 119, στο κέντρο της Πάτρας, απέχει μόλις 10-15 λεπτά με αυτοκίνητο ή λεωφορείο. Και αν η μετακίνηση δεν βολεύει, οι online συνεδρίες έχουν ακριβώς την ίδια ποιότητα και εμπιστευτικότητα.",
    points: [
      {
        title: "10-15 λεπτά από το Ρίο",
        desc: "Το γραφείο βρίσκεται σε κεντρικό, εύκολα προσβάσιμο σημείο της Πάτρας — με στάσεις λεωφορείων κοντά και parking στην περιοχή.",
      },
      {
        title: "Και για την απέναντι όχθη",
        desc: "Δέχομαι ανθρώπους από το Αντίρριο και τη Ναύπακτο — η γέφυρα κάνει τη διαδρομή σύντομη, και το online την κάνει μηδενική.",
      },
      {
        title: "Γνωσιακή Συμπεριφορική (CBT)",
        desc: "Η πιο ερευνητικά τεκμηριωμένη μέθοδος για άγχος, OCD, κατάθλιψη, φοβίες και χαμηλή αυτοεκτίμηση.",
      },
      {
        title: "Ευέλικτα απογεύματα",
        desc: "Απογευματινές ώρες έως τις 20:00, ώστε η συνεδρία να χωράει στο πρόγραμμά σου μετά τη δουλειά.",
      },
    ],
    faqs: [
      {
        q: "Πόσο απέχει το γραφείο από το Ρίο;",
        a: "Περίπου 10-15 λεπτά με αυτοκίνητο από το Ρίο και την Πανεπιστημιούπολη. Η διεύθυνση είναι Ρήγα Φεραίου 119, στο κέντρο της Πάτρας, με στάσεις αστικών λεωφορείων σε κοντινή απόσταση.",
      },
      {
        q: "Εξυπηρετείς και Αντίρριο ή Ναύπακτο;",
        a: "Ναι. Αρκετοί άνθρωποι έρχονται από την απέναντι όχθη μέσω της γέφυρας Ρίου-Αντιρρίου, ενώ πολλοί προτιμούν τις online συνεδρίες που έχουν ισάξια αποτελεσματικότητα.",
      },
      {
        q: "Μπορώ να συνδυάσω δια ζώσης και online συνεδρίες;",
        a: "Φυσικά. Μπορούμε να κάνουμε τις συνεδρίες δια ζώσης όταν σε βολεύει και online όταν το πρόγραμμα ή ο καιρός δεν βοηθούν — χωρίς να χαθεί η συνέχεια της θεραπείας.",
      },
    ],
  },
  {
    slug: "psixologos-aigio",
    badge: "Αίγιο & Αιγιάλεια",
    metaTitle: "Ψυχολόγος Αίγιο · Ψυχοθεραπεία CBT δια ζώσης & online | Άννα Παπαχρονόπουλου",
    metaDescription:
      "Ψυχοθεραπεία για το Αίγιο και την Αιγιάλεια: συνεδρίες CBT στο γραφείο στην Πάτρα (30' από το Αίγιο) ή online με πλήρη εμπιστευτικότητα. Άγχος, OCD, κατάθλιψη, αυτοεκτίμηση.",
    keywords:
      "ψυχολόγος Αίγιο, ψυχοθεραπεία Αίγιο, ψυχολόγος Αιγιάλεια, ψυχολόγος κοντά στο Αίγιο, online ψυχολόγος Αίγιο, CBT Αίγιο",
    h1a: "Ψυχοθεραπεία",
    h1b: "για το Αίγιο.",
    sub: "Κοντά σου — από κοντά ή online.",
    intro:
      "Στο Αίγιο και στην ευρύτερη Αιγιάλεια οι επιλογές για εξειδικευμένη ψυχοθεραπεία είναι περιορισμένες. Το γραφείο μου στην Πάτρα απέχει περίπου 30 λεπτά από την εθνική οδό — και για όσες φορές η μετακίνηση δεν βολεύει, οι online συνεδρίες προσφέρουν ακριβώς την ίδια θεραπευτική σχέση, χωρίς δρόμο.",
    points: [
      {
        title: "30 λεπτά από το Αίγιο",
        desc: "Εύκολη πρόσβαση από την εθνική οδό. Οι συνεδρίες μπορούν να προγραμματιστούν σε ώρες που βολεύουν τη μετακίνηση.",
      },
      {
        title: "Online με πλήρη εμπιστευτικότητα",
        desc: "Σε μικρότερες πόλεις η διακριτικότητα μετράει. Online δεν συναντάς κανέναν στον... διάδρομο — μόνο εμένα στην οθόνη.",
      },
      {
        title: "Σταθερό εβδομαδιαίο ραντεβού",
        desc: "Κρατάμε σταθερή μέρα και ώρα ώστε η θεραπεία να γίνει ρουτίνα — δια ζώσης, online ή συνδυαστικά.",
      },
      {
        title: "Γνωσιακή Συμπεριφορική (CBT)",
        desc: "Τεκμηριωμένη, στοχευμένη μέθοδος με πρακτικά εργαλεία για άγχος, κατάθλιψη, OCD και αυτοεκτίμηση.",
      },
    ],
    faqs: [
      {
        q: "Αξίζει να έρχομαι από το Αίγιο για συνεδρία;",
        a: "Πολλοί άνθρωποι από το Αίγιο και την Αιγιάλεια προτιμούν τη δια ζώσης επαφή και συνδυάζουν τη συνεδρία με άλλες δουλειές στην Πάτρα. Εναλλακτικά, οι online συνεδρίες έχουν αποδεδειγμένα ισάξια αποτελεσματικότητα.",
      },
      {
        q: "Πόσο συχνά γίνονται οι συνεδρίες;",
        a: "Συνήθως μία φορά την εβδομάδα στην αρχή, με σταθερή μέρα και ώρα. Όσο προχωράει η θεραπεία, οι συνεδρίες αραιώνουν.",
      },
      {
        q: "Είναι εμπιστευτικό αν κάνω online συνεδρίες;",
        a: "Απολύτως. Οι βιντεοκλήσεις γίνονται μέσω ασφαλούς πλατφόρμας, δεν καταγράφονται, και ό,τι λέγεται καλύπτεται από το απόρρητο — ακριβώς όπως στο γραφείο.",
      },
    ],
  },
  {
    slug: "psixologos-foitites-patras",
    badge: "Πανεπιστήμιο Πατρών · Φοιτητές",
    metaTitle: "Ψυχολόγος για Φοιτητές Πάτρα · Ειδική φοιτητική τιμή | Άννα Παπαχρονόπουλου",
    metaDescription:
      "Ψυχοθεραπεία για φοιτητές του Πανεπιστημίου Πατρών: άγχος εξεταστικής, προσαρμογή, μοναξιά, αναβλητικότητα. Ειδική φοιτητική τιμή. Κοντά στην Πανεπιστημιούπολη ή online.",
    keywords:
      "ψυχολόγος φοιτητές Πάτρα, ψυχολόγος Πανεπιστήμιο Πατρών, φοιτητικό άγχος, ψυχολόγος φοιτητική τιμή, άγχος εξεταστικής, ψυχοθεραπεία φοιτητές",
    h1a: "Ψυχοθεραπεία",
    h1b: "για φοιτητές.",
    sub: "Με φοιτητική τιμή.",
    intro:
      "Τα φοιτητικά χρόνια δεν είναι πάντα «τα καλύτερα της ζωής σου» — και δεν χρειάζεται να προσποιείσαι ότι είναι. Άγχος εξεταστικής, αναβλητικότητα, μοναξιά μακριά από το σπίτι, δύσκολες σχέσεις, πίεση για το μέλλον: όλα αυτά έχουν λύση. Δέχομαι φοιτητές και φοιτήτριες του Πανεπιστημίου Πατρών με ειδική φοιτητική τιμή — στο γραφείο ή online.",
    points: [
      {
        title: "Ειδική φοιτητική τιμή",
        desc: "Η ψυχοθεραπεία πρέπει να είναι προσιτή και με το budget ενός φοιτητή. Ρώτησέ με χωρίς δισταγμό στο πρώτο μήνυμα.",
      },
      {
        title: "Άγχος εξεταστικής & αναβλητικότητα",
        desc: "Πρακτικά εργαλεία CBT για τον πανικό πριν τις εξετάσεις, το ξενύχτι-ενοχή-ξενύχτι και το «θα το ξεκινήσω αύριο».",
      },
      {
        title: "Προσαρμογή & μοναξιά",
        desc: "Η μετακόμιση σε νέα πόλη, η απόσταση από οικογένεια και φίλους, το αίσθημα ότι «όλοι οι άλλοι τα έχουν βρει» — μιλάμε για όλα.",
      },
      {
        title: "Online στις διακοπές & την εξεταστική",
        desc: "Όταν γυρνάς στην πόλη σου ή κλείνεσαι για διάβασμα, η θεραπεία συνεχίζεται κανονικά μέσω βιντεοκλήσης.",
      },
    ],
    faqs: [
      {
        q: "Πόσο κοστίζει η συνεδρία για φοιτητές;",
        a: "Υπάρχει ειδική μειωμένη τιμολόγηση για φοιτητές (όπως και για ανέργους και ΑμεΑ). Το ακριβές κόστος συζητείται στην πρώτη επικοινωνία — στείλε μήνυμα χωρίς καμία δέσμευση.",
      },
      {
        q: "Θα το μάθουν οι γονείς μου;",
        a: "Όχι. Αν είσαι ενήλικας, ό,τι συζητάμε καλύπτεται πλήρως από το επαγγελματικό απόρρητο. Κανείς δεν ενημερώνεται χωρίς τη δική σου ρητή συγκατάθεση.",
      },
      {
        q: "Μπορώ να συνεχίσω όταν φεύγω από την Πάτρα;",
        a: "Ναι — στις διακοπές, την εξεταστική ή την πρακτική σου, οι συνεδρίες συνεχίζονται online χωρίς διακοπή της θεραπευτικής πορείας.",
      },
      {
        q: "Το γραφείο είναι κοντά στην Πανεπιστημιούπολη;",
        a: "Βρίσκεται στη Ρήγα Φεραίου 119, στο κέντρο της Πάτρας — περίπου 15 λεπτά από την Πανεπιστημιούπολη στο Ρίο με λεωφορείο ή αυτοκίνητο.",
      },
    ],
  },
];
